require("~globalstyles/styles.scss");

exports.onClientEntry = () => {};
